import classNames from 'classnames';

import styles from './styles.module.scss';
import { Props } from './types';

const IconButton = ({
  type = 'button',
  disabled = false,
  children,
  className,
  href,
  ...props
}: Props) => {
  const Button = (
    <button
      className={classNames(className, styles.iconButton)}
      type={type}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
  if (href) {
    return (
      <a href={href} className={styles.iconButton__link}>
        {Button}
      </a>
    );
  }
  return Button;
};

export default IconButton;
